// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XeZb","name":"styles_name__2QMSk","phone":"styles_phone__3KylT"};